import { createConfig, http, injected } from "wagmi";
import { arbitrum } from "wagmi/chains";
import { defineChain } from "viem";

export const hyperEvm = defineChain({
  id: 999,
  name: "HyperEVM",
  nativeCurrency: { name: "HYPE", symbol: "HYPE", decimals: 18 },
  rpcUrls: { default: { http: ["https://rpc.hyperliquid.xyz/evm"] } },
  blockExplorers: { default: { name: "HyperEVMScan", url: "https://hyperevmscan.io" } },
});

// Injected wallets only, each announced through EIP-6963. HyperEVM signs papertrade's intents;
// Arbitrum is the chain Hyperliquid's own signatures name, which a deposit's sends are signed on.
export const wagmiConfig = createConfig({
  chains: [hyperEvm, arbitrum],
  connectors: [injected()],
  multiInjectedProviderDiscovery: true,
  transports: { [hyperEvm.id]: http(), [arbitrum.id]: http() },
});

export type ChainId = (typeof wagmiConfig)["chains"][number]["id"];

declare module "wagmi" {
  interface Register {
    config: typeof wagmiConfig;
  }
}
